import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const Dashboard = lazy(() => import('../../container/dashboard'));
const AuthorizedFilers = lazy(() => import('../../container/dashboard/AuthorizedFilers'))
const FormsPage = lazy(() => import('../../container/dashboard/formspage'))
const NotFound = lazy(() => import('../../container/pages/404'));

function DashboardRoutes() {
  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="filers" element={<AuthorizedFilers />} />
      <Route path="forms" element={<FormsPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default DashboardRoutes;
